<template>
  <div class="authView">
    <div class="loginForm">
      <label for="first">用户名
        <input type="text" id="first" class="form-control" v-model="form.key" placeholder="usename" :mexlength="11">
      </label>
      <label label="password">密码
        <input id="password" type="text" class="form-control" v-model="form.password" placeholder="password" />
      </label>
      <button type="button" @click="handleLogin">登录</button>
    </div>
    <div class="loginForm">
      <label for="first">手机号
        <input type="text" id="first" class="form-control" v-model="code.telephone" placeholder="usename" :mexlength="11">
      </label>
      <label label="password">验证码
        <input id="password" type="text" class="form-control" v-model="code.code" placeholder="password" />
      </label>
      <button type="button" @click="handleCodeLogin">登录</button>
    </div>
  </div>
</template>

<script>
import authApi from '@/services/server'
export default {
  data () {
    return {
      form: {
        key: '17310291916',
        password: '111111'
      },
      code: {
        telephone: '15010776522',
        code: '111111'
      }
    }
  },
  methods: {
    handleLogin () {
      authApi.auth(this.form).then(res => {
        if (res.ok) {
          this.$router.push({ path: '/' })
        }
      })
    },
    handleCodeLogin () {
      authApi.codeLogin(this.code).then(res => {
        if (res.ok) {
          this.$router.push({ path: '/' })
        }
      })
    }
  }
}
</script>

<style scoped>
.loginForm {
  width: 500px;
  margin: 100px auto;
}
</style>
